import React from "react";
import RoleGuard from "./RoleGuard";

interface CRMRouteGuardProps {
  children: React.ReactNode;
}

const CRMRouteGuard: React.FC<CRMRouteGuardProps> = ({ children }) => {
  return (
    <RoleGuard restrictedRoles={["SUPERADMIN", "PLATFORM_ANALYST"]}>
      {children}
    </RoleGuard>
  );
};

export default CRMRouteGuard;
